import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/roster.actions'
import * as employeeLeaveActions from '../../_actions/employeeLeave.actions'
import * as branchActions from '../../_actions/branch.actions'
import * as departmentActions from '../../_actions/department.actions'
import _ from 'lodash'
import { Drawer, Select, Collapse, Button } from 'antd'
import BrancheSelect from '../common/BrancheSelect'
import DepartmentSelect from '../common/DepartmentSelect'
import CustomSpinner from '../common/CustomSpinner'
import { viewConstants } from '../../_constants/view.constants'

// const empSelectOption = [
//     { name: 'All', icon: 'pi pi-fw pi-check', value: 1 },
//     { name: 'Clear', icon: 'pi pi-fw pi-times', value: 0 },
// ]

const { Panel } = Collapse

const options = []

// for (let i = 10; i < 36; i++) {
//     options.push({
//         label: i.toString(36) + i,
//         value: i.toString(36) + i,
//     })
// }

class EmpListView extends PureComponent {
    state = {
        selectedBranch: {},
        selectedDepartment: {},
        displayEmployees: [],
        currentEmployees: [],
        selectedEmployee: '',
        checked: false,
        selectAll: null,
        checkAll: false,
        badge: '',
        openFilterDrawer: false,
        disableEmployeeFilter: false,
        checked: false,
    }

    employeeTemplate = option => {
        return (
            <div className="">
                <div>{option.name}</div>
            </div>
        )
    }

    componentDidMount() {
        if (this.props.employees.length == 0) {
            this.props.actions.fetchEmployeeList()
        }

        // Fetch branches and departments on mount
        if (this.props.branches.length === 0) {
            this.props.branchActions.fetchBranchList()
        }
        
        if (this.props.departments.length === 0) {
            this.props.departmentActions.fetchDepartmentList()
        }

        // this.props.actions.selectBranches([])
        // this.props.actions.selectDepartments([])
    }

    // selectAllEmployeeOptions = () => {
    //   const allOptions = this.displayEmployees()
    //   let value = []
    //   _.forEach(allOptions, option => {
    //     value.push(option.value)
    //   })

    //   this.setState({selectedEmployees: value})
    // }

    displayEmployees = () => {
        const empOption = this.props.displayEmployees.map(emp => {
            let o = {}
            o.label = emp.EmployeeName
            o.value = emp.key
            return o
        })

        return empOption
    }

    displayEmployeeIds = () => {
        const ids = this.props.displayEmployees.map(emp => {
            return emp.EmployeeAutoID
        })
        return ids
    }

    // handleSelection = option => {
    //     // this.setState({ selectedEmployees: option })

    //     this.props.actions.selectEmployees(option)

    //     const { selectedBranch, selectedDepartment } = this.state
    //     this.props.actions.updateDisplayRoster({
    //         employees: option,
    //         EmployeeBranch:
    //             selectedBranch === undefined || selectedBranch.id === 'all'
    //                 ? undefined
    //                 : selectedBranch.id,
    //         EmployeeDepartment:
    //             selectedDepartment === undefined ||
    //             selectedDepartment.id === 'all'
    //                 ? undefined
    //                 : selectedDepartment.id,
    //     })
    // }

    handleBranchChange = async branch => {
        // reset employee list
        await this.props.actions.selectEmployees([])
        // set branch filter
        await this.props.actions.selectBranches(branch)

        // update display employee and roster
        let filterCond = {}

        if (!_.isEmpty(branch)) {
            filterCond.EmployeeBranch = branch
        }
        if (!_.isEmpty(this.props.selectedDepartments)) {
            filterCond.EmployeeDepartment = this.props.selectedDepartments
        }

        await this.props.actions.updateDisplayEmployee(filterCond)

        // fetch leave
        var cond = {}
        const options = {
            range: viewConstants.MONTH,
            time: this.props.currentDate,
        }

        if (!_.isEmpty(this.props.displayEmployees)) {
            cond.employees = this.displayEmployeeIds()

            this.props.leaveActions.fetchEmployeeLeave(
                Object.assign({}, cond, options)
            )
        } else {
            // update display leave: empty
            this.props.leaveActions.updateDisplayLeave({displayEvents:[]})
        }
    }

    handleDepartmentChange = async department => {
        // reset employee list
        await this.props.actions.selectEmployees([])
        // set branch filter
        await this.props.actions.selectDepartments(department)

        // update display employee and roster
        let filterCond = {}
        if (!_.isEmpty(department)) {
            filterCond.EmployeeDepartment = department
        }

        if (!_.isEmpty(this.props.selectedBranches)) {
            filterCond.EmployeeBranch = this.props.selectedBranches
        }

        // dispatch sync action
        await this.props.actions.updateDisplayEmployee(filterCond)

        // fetch leave
        var cond = {}
        const options = {
            range: viewConstants.MONTH,
            time: this.props.currentDate,
        }

        if (!_.isEmpty(this.props.displayEmployees)) {
            cond.employees = this.displayEmployeeIds()

            this.props.leaveActions.fetchEmployeeLeave(
                Object.assign({}, cond, options)
            )
        } else {
            this.props.leaveActions.updateDisplayLeave({displayEvents:[]})
        }

        // if (!_.isEmpty(this.props.displayEmployees)) {
        //     cond.employees = this.displayEmployeeIds()
        //     this.props.leaveActions.fetchEmployeeLeave(
        //         Object.assign({}, cond, options)
        //     )
        // } else {
        //     this.props.actions.updateDisplayRoster({ displayEvents: [] })
        // }
        // if (!_.isEmpty(department)) {
        //     cond.departments = department
        // }
        // if (!_.isEmpty(this.props.selectedBranches)) {
        //     cond.branches = this.props.selectedBranches
        // }

        // this.props.leaveActions.fetchEmployeeLeave(
        //     Object.assign({}, cond, options)
        // )
    }

    showFilterDrawer = () => {
        this.setState({
            openFilterDrawer: true,
        })
    }

    closeFilterDrawer = () => {
        this.setState({
            openFilterDrawer: false,
        })
    }

    // handleFilter = () => {
    //     var cond = {}

    //     if (!_.isEmpty(this.props.selectedEmployees)) {
    //         cond.employees = this.props.selectedEmployees
    //     }
    //     if (!_.isEmpty(this.props.selectedBranches)) {
    //         cond.branches = this.props.selectedBranches
    //     }
    //     if (!_.isEmpty(this.props.selectedDepartments)) {
    //         cond.departments = this.props.selectedDepartments
    //     }

    //     this.props.actions.fetchUserETime(cond)
    // }

    handleReset = async () => {
        this.props.actions.selectEmployees([])
        this.props.actions.selectBranches([])
        this.props.actions.selectDepartments([])

        // update display employee and roster
        let filterCond = {}
        filterCond.EmployeeDepartment = []
        filterCond.EmployeeBranch = []

        // dispatch sync action
        await this.props.actions.updateDisplayEmployee(filterCond)

        var cond = {}
        const options = {
            range: viewConstants.MONTH,
            time: this.props.currentDate,
        }

        this.props.leaveActions.fetchEmployeeLeave(
            Object.assign({}, cond, options)
        )
    }

    handleChange = value => {
        // this.setState({selectedEmployees: value})

        this.props.actions.selectEmployees(value)

        var cond = {}

        const options = {
            range: viewConstants.MONTH,
            time: this.props.currentDate,
        }

        if (!_.isEmpty(value)) {
            cond.employees = value
        }
        // if (!_.isEmpty(this.props.selectedBranches)) {
        //     cond.branches = this.props.selectedBranches
        // }
        // if (!_.isEmpty(this.props.selectedDepartments)) {
        //     cond.departments = this.props.selectedDepartments
        // }

        // this.props.actions.fetchUserETime(Object.assign({}, cond, options))

        this.props.leaveActions.fetchEmployeeLeave(
            Object.assign({}, cond, options)
        )
    }

    onCollapseChange = key => {}

    // onSearch = (value) => {
    //   const options = this.displayEmployees()

    // };

    render() {
        const badge = this.props.selectedEmployees
            ? `${this.props.selectedEmployees.length}`
            : ''
        return (
            <div className="">
                <div className="empview">
                    {this.props.loading ? (
                        <CustomSpinner />
                    ) : (
                        <div>
                            <Collapse
                                defaultActiveKey={['1', '2', '3']}
                                onChange={this.onCollapseChange}
                                expandIconPosition="end"
                                ghost={true}
                                bordered={false}
                                accordion={false}
                            >
                                <Panel header="Employee" key="1">
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        style={{
                                            width: '100%',
                                        }}
                                        placeholder="Select employees"
                                        defaultValue={[]}
                                        onChange={this.handleChange}
                                        options={this.displayEmployees()}
                                        disabled={
                                            this.state.disableEmployeeFilter
                                        }
                                        value={this.props.selectedEmployees}
                                        maxTagCount="responsive"
                                        filterOption={(input, option) =>
                                            (option?.label ?? '')
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                    />
                                </Panel>
                                {!_.isEmpty(this.props.branches) && (
                                    <Panel header="Branch" key="2">
                                        <BrancheSelect
                                            selectedBranches={
                                                this.props.selectedBranches
                                            }
                                            handleChange={this.handleBranchChange.bind(
                                                this
                                            )}
                                        />
                                    </Panel>
                                )}
                                {!_.isEmpty(this.props.departments) && (
                                    <Panel header="Department" key="3">
                                        <DepartmentSelect
                                            selectedDepartments={
                                                this.props.selectedDepartments
                                            }
                                            handleChange={this.handleDepartmentChange.bind(
                                                this
                                            )}
                                        />
                                    </Panel>
                                )}
                            </Collapse>
                            <div className="m-4">
                                {/* <Button
                                    htmlType="button"
                                    type="primary"
                                    onClick={this.handleFilter}
                                >
                                    Search
                                </Button> */}
                                <Button
                                    htmlType="button"
                                    onClick={this.handleReset}
                                >
                                    Reset
                                </Button>
                            </div>
                        </div>
                        // <div className="">
                        //     <Button
                        //         icon="pi pi-check"
                        //         label="All"
                        //         className="p-button-raised p-button-text"
                        //         badge={badge}
                        //         onClick={this.handleAllSelection}
                        //     />
                        //     <Button
                        //         icon="pi pi-times"
                        //         label="Clear"
                        //         className="p-button-raised p-button-text p-button-plain"
                        //         onClick={this.handleDeSelection}
                        //     />
                        //     <div className="">
                        //         <div className="">
                        //             <ListBox
                        //                 value={this.props.selectedEmployees}
                        //                 options={this.displayEmployees()}
                        //                 onChange={e =>
                        //                     this.handleSelection(e.value)
                        //                 }
                        //                 multiple
                        //                 // filter
                        //                 // filterPlaceholder="type name"
                        //                 optionLabel="name"
                        //                 itemTemplate={this.employeeTemplate.bind(
                        //                     this
                        //                 )}
                        //                 style={{
                        //                     border: 'none',
                        //                     width: '14rem',
                        //                 }}
                        //                 // listStyle={{ maxHeight: '250px' }}
                        //             />
                        //         </div>
                        //     </div>
                        // </div>
                    )}
                </div>
                {/* <div>
                    <label>filter</label>
                    <Button
                        id="filter"
                        type="primary"
                        onClick={this.showFilterDrawer}
                    >
                        Open
                    </Button>
                    <Button
                        id="filter"
                        type="primary"
                        onClick={this.showFilterDrawer}
                    >
                        Open
                    </Button>
                </div> */}

                <Drawer
                    title="Basic Drawer"
                    placement="right"
                    onClose={this.closeFilterDrawer}
                    open={this.state.openFilterDrawer}
                >
                    <p>Some contents...</p>
                    <p>Some contents...</p>
                    <p>Some contents...</p>
                </Drawer>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        loading: state.roster.loadingEmpoyeeList,
        currentDate: state.roster.currentDate,
        employees: state.roster.employeeList,
        displayEmployees: state.roster.displayEmployees,
        selectedEmployees: state.roster.selectedEmployees,
        selectedBranches: state.roster.selectedBranches,
        selectedDepartments: state.roster.selectedDepartments,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(instructorActions, dispatch),
        leaveActions: bindActionCreators(employeeLeaveActions, dispatch),
        branchActions: bindActionCreators(branchActions, dispatch),
        departmentActions: bindActionCreators(departmentActions, dispatch),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmpListView)
